module.exports = __webpack_public_path__ + "static/media/checked-active.a2dd1d27.svg";